import styled from 'styled-components';

export const TableWrapper = styled.div`
  border-radius: 10px;
  background: #fff;
  box-shadow: 0px 4px 12px 0px rgba(0, 0, 0, 0.04);

  overflow: auto;
  /* min-height: 747px; */
  min-height: 875px;
  justify-content: space-between;
  display: flex;
  flex-direction: column;
  width: 100%;
`;

export const StyledTable = styled.table`
  border-collapse: collapse;
  border-spacing: 0;
`;

export const TableHeader = styled.thead`
  height: 5rem;
  display: flex;
  align-items: center;
`;

export const TableHeaderRow = styled.tr`
  display: flex;
  flex: 1;
  /* gap: 4rem; */
  justify-content: space-between;
`;

export const TableHeaderItem = styled.th`
  color: #000;
  font-family: 'Poppins-Medium';
  font-weight: 500;
  font-size: 14px;
  letter-spacing: -0.408px;
  display: flex;
  /* flex: 1; */
  max-width: 250px;
  width: 250px;
  align-items: center;

  &:first-of-type {
    justify-content: flex-start;

    padding-left: 1.6rem;
  }
  &:last-of-type {
    justify-content: flex-end;
    padding-right: 16px;
    max-width: ${props => (props.$chevron ? '50px' : '250px')};
    min-width: ${props => (props.$chevron ? '50px' : '250px')};
    width: ${props => (props.$chevron ? '50px' : '250px')};
  }

  justify-content: center;

  min-width: 10rem;
  opacity: 0.5;
`;

export const ExpandableTableHeaderItem = styled.th`
  width: 5.2rem;
`;

export const TableBody = styled.tbody``;

export const TableBodyRow = styled.tr`
  justify-content: space-between;
  display: flex;
  cursor: pointer;
  width: 100%;

  min-height: 6.4rem;
  /* gap: 4rem; */
  &:last-of-type {
    border-bottom: none;
  }
  &:hover {
    background-color: rgba(245, 237, 239, 0.35);
    transition: all 0.2s ease-in-out;
  }
`;
export const TableBodyRowEmpty = styled.tr`
  display: flex;
  width: 100%;
  height: 100%;
  position: absolute;

  text-align: center;
  align-items: center;
  justify-content: center;
`;

export const TableBodyItemEmpty = styled.td`
  color: #000;
  flex: 1;

  font-size: 15px;
  font-family: 'Poppins-Medium';
  letter-spacing: -0.408px;
  display: flex;
  justify-content: center;

  align-items: center;
  gap: 12px;
`;
export const TableBodyItem = styled.td`
  color: #000;

  flex: 1;
  font-size: 15px;
  font-family: 'Poppins-Medium';
  letter-spacing: -0.408px;
  display: flex;

  align-items: center;
  gap: 12px;
  width: 250px;
  max-width: 250px;
  justify-content: center;

  &:first-of-type {
    justify-content: flex-start;
  }
  &:last-of-type {
    justify-content: flex-end;
  }
`;
export const Td = styled.td`
  flex: 1;
  display: flex;
  align-items: center;
`;

export const PaginationContainer = styled.div`
  display: flex;
  width: 100%;
  justify-content: flex-end;
  padding: 1.6rem 2.4rem;
  border-top: 1px solid rgba(0, 0, 0, 0.05);
`;

export const Spinner = styled.img`
  height: 4rem;
  object-fit: contain;
`;

export const TableItemContainer = styled.div``;

export const ProfilePhotoContainer = styled.div`
  width: 32px;
  height: 32px;
  border-radius: 16px;
  background: linear-gradient(0deg, #f1e4df 0%, #f1e4df 100%);
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const ProfilePhoto = styled.img`
  width: 32px;
  height: 32px;
  border-radius: 16px;
`;
